import { CardStyleInterpolators } from "@react-navigation/stack";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { SwitchUserScreen } from "../SwitchUserScreen/SwitchUserScreen";
import { SwitchUserRootParamList } from "../../../../types";
import { SwitchUserEnterCredentialsScreen } from "../SwitchUserEnterCredentialsScreen";

export const SwitchUserRootScreen = () => {
  const RootNavigator = createStackHeaderNavigator<SwitchUserRootParamList>();
  return (
    <RootNavigator.Navigator>
      <RootNavigator.Group
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <RootNavigator.Screen
          options={{ title: "" }}
          name="SwitchUserScreen"
          component={SwitchUserScreen}
        />
        <RootNavigator.Screen
          name="SwitchUserEnterCredentialsScreen"
          component={SwitchUserEnterCredentialsScreen}
        />
      </RootNavigator.Group>
    </RootNavigator.Navigator>
  );
};
